const TOOL_DISPLAY_NAME_OVERRIDES: Record<string, string> = {
    get_jobs: 'Get jobs'
};

const STRIP_SEGMENTS = new Set(['mcp', 'titan']);

function titleCaseSegments(value: string): string {
    const parts = value.split(/[^a-zA-Z0-9]+/).filter((segment) => {
        if (!segment) return false;
        return !STRIP_SEGMENTS.has(segment.toLowerCase());
    });
    if (parts.length === 0) return '';
    return parts.map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1)).join(' ');
}

export function formatToolDisplayName(rawName: string | undefined | null): string {
    const normalized = rawName?.trim();
    if (!normalized) return 'Tool';
    const override = TOOL_DISPLAY_NAME_OVERRIDES[normalized];
    if (override) return override;
    const titled = titleCaseSegments(normalized);
    return titled || 'Tool';
}

export { TOOL_DISPLAY_NAME_OVERRIDES };
